'use client';
import { useSaleBanner } from '../../../hooks/useSaleBanner';
import dynamic from 'next/dynamic';

const SaleBanner = dynamic(() => import('./SaleBanner'), { ssr: false });

/**
 * Wraps SaleBanner so it can be lazy-loaded with next/dynamic.
 */
export default function SaleBannerWrapper() {
  const salebannerProps = useSaleBanner();
  if (!salebannerProps.isVisible) return;

  return <SaleBanner {...salebannerProps} />;
}
